/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Activate_AccountInputs */

const en_batch_subtitle_export_activate_account = /** @type {(inputs: Batch_Subtitle_Export_Activate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate Account`)
};

const fr_batch_subtitle_export_activate_account = /** @type {(inputs: Batch_Subtitle_Export_Activate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer le compte`)
};

const de_batch_subtitle_export_activate_account = /** @type {(inputs: Batch_Subtitle_Export_Activate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto aktivieren`)
};

const it_batch_subtitle_export_activate_account = /** @type {(inputs: Batch_Subtitle_Export_Activate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva account`)
};

const ru_batch_subtitle_export_activate_account = /** @type {(inputs: Batch_Subtitle_Export_Activate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активировать аккаунт`)
};

const es_batch_subtitle_export_activate_account = /** @type {(inputs: Batch_Subtitle_Export_Activate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar cuenta`)
};

const zh_cn2_batch_subtitle_export_activate_account = /** @type {(inputs: Batch_Subtitle_Export_Activate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活账户`)
};

const ja_batch_subtitle_export_activate_account = /** @type {(inputs: Batch_Subtitle_Export_Activate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを有効化`)
};

const hi_batch_subtitle_export_activate_account = /** @type {(inputs: Batch_Subtitle_Export_Activate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता सक्रिय करें`)
};

const pt_pt2_batch_subtitle_export_activate_account = /** @type {(inputs: Batch_Subtitle_Export_Activate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar conta`)
};

/**
* | output |
* | --- |
* | "Activate Account" |
*
* @param {Batch_Subtitle_Export_Activate_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_activate_account = /** @type {((inputs?: Batch_Subtitle_Export_Activate_AccountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Activate_AccountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_activate_account(inputs)
	if (locale === "de") return de_batch_subtitle_export_activate_account(inputs)
	if (locale === "it") return it_batch_subtitle_export_activate_account(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_activate_account(inputs)
	if (locale === "es") return es_batch_subtitle_export_activate_account(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_activate_account(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_activate_account(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_activate_account(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_activate_account(inputs)
	return en_batch_subtitle_export_activate_account(inputs)
});